export default __webpack_public_path__ + "img/whoIsWho.9fba56e2.svg";